'use strict';

var $u = require('../utilities');
var $d = require('../dependency');
var _ = $d._;
var moment = $d.moment;

exports.druidQueryGenerator = druidQueryGenerator;

/**
 * [druidQueryGenerator generates druid type queries from linear key value pairs.]
 * @param  {object}   queryParamObject [the linear query object to generate queries from.]
 * @param  {object}   config       [predefined task context]
 * @param  {function} next          [callback for the success case. Apply the success object here.]
 * @param  {function} next           [callback for the failure case. Apply the error/failure object here.]
 * @return {object}                    [the druid query POST data.]
 */
function druidQueryGenerator(context, config, next) {
  var queryObject,
    queryObjectList = [],
    dataConfig = context.dataConfig,
    userBaseTimeString = moment(context.baseTime).toISOString(),
    durationFilterValue = context.durationFilterValue,
    granularityOverride,
    queryGranularity,
    durationFilter;

  _.forEach(dataConfig, function (inputQueryObject) {
    queryObject = {};
    //for overidden granularity
    if (inputQueryObject.granularityOverride) {
      granularityOverride = inputQueryObject.granularityOverride;
    }

    //Handle the case for custom duration
    if(durationFilterValue === 'custom'){
      durationFilter = _.find(context.filter, {id:"duration"}) || _.find(context.filter, {id:"date"});

      if(durationFilter){
        queryGranularity = $u.generic.findCustomGranularity(durationFilterValue, durationFilter, granularityOverride);
        queryObject.intervals = $u.generic.findCustomInterval(durationFilterValue, durationFilter, queryGranularity);
        queryObject.granularity = queryGranularity;
      }
    } else {
      queryObject.granularity = $u.generic.findGranularityFromDays(durationFilterValue, granularityOverride);
      queryObject.intervals = $u.generic.findInterval(durationFilterValue, userBaseTimeString);
    }

    //!ToDo use lodash assign.
    queryObject.dataSource = inputQueryObject.dataSource;
    queryObject.queryType = inputQueryObject.queryType;
    queryObject.aggregations = inputQueryObject.aggregations;
    queryObject.postAggregations = inputQueryObject.postAggregations;


    if (inputQueryObject.queryType === 'timseries') {

    } else if (inputQueryObject.queryType === 'topN') {
      queryObject.metric = inputQueryObject.metric;
      queryObject.threshold = inputQueryObject.threshold;
      queryObject.dimension = inputQueryObject.dimension;
    } else if (inputQueryObject.queryType === 'groupBy') {
      queryObject.dimensions = inputQueryObject.dimensions;
    } else {

    }
    queryObjectList.push(queryObject);
  });

  context.granularity = queryGranularity;
  context.queryObjectList = queryObjectList;
  context.intervals = _.map(queryObjectList,'intervals');
  next();

}